class CustomerService {
	constructor(options) {
		this.options = options;
		this.customerServicePanel = document.getElementById(this.options.wrapper);

		if (this.customerServicePanel) {
			this.panelHeading = document.getElementById('customerServicePanelHeader');
			this.feedbackButton = document.getElementById(
				'customerServicePanelFeedbackButton',
			);
			this.bindEvents();
		}
	}

	bindEvents() {
		if (this.panelHeading) {
			this.panelHeading.addEventListener('click', () => {
				this.toggleIsActive();
			});
		}

		if (this.feedbackButton) {
			this.feedbackButton.addEventListener('click', e => {
				e.preventDefault();
				this.removeIsActive();
			});
		}
	}

	toggleIsActive() {
		this.customerServicePanel.classList.toggle(
			'customer-service-panel--is-active',
		);
	}

	removeIsActive() {
		this.customerServicePanel.classList.remove(
			'customer-service-panel--is-active',
		);
	}
}

export default CustomerService;
